import AbstractModel from './abstract-model';
import { FILE_PROXY_URL } from '../services';

const viewables = /^image/;

export default abstract class CavAbstractDocument extends AbstractModel {

  abstract getDownloadPath() :string;

  public id: number = null;
  public idCavite: string = null;
  public titre: string = null;
  public file: string = null;
  public originalFile: string = null;
  public mimeType: string = null;

  getUrl(){

    if (! this.hasFile()){
      throw new Error("unable to get file url");
    }
    const query = this.id === null ? `tmp=true&ofn=${encodeURIComponent(this.originalFile)}` : "";
    return `${FILE_PROXY_URL}/${this.getDownloadPath()}/${this.id || this.file}?${query}`;
  }

  hasFile() {
    return typeof this.mimeType === "string" && typeof this.file === "string" && typeof this.originalFile === "string";
  }

  isImage(){
    return this.hasFile() && viewables.test(this.mimeType);
  }

}
